import { render } from "./PopUpSecularism.vue?vue&type=template&id=c2989174"
import script from "./PopUpSecularism.vue?vue&type=script&lang=js"
export * from "./PopUpSecularism.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__